const t = "tag", a = {
  tag: "tag"
};
export {
  a as default,
  t as tag
};
